<template>

    <div class="order-status">
        <div class="user-avatar-wrap normal">
            <a target="_blank" :href="'/writers/'+comment.commentable.writer.name">
                <figure class="user-avatar normal">
                    <img :src="'/images/avatars/'+comment.commentable.writer.avatar" alt="">
                </figure>
            </a>
        </div>
        <div>
            <a target="_blank" :href="'/writers/'+comment.commentable.writer.name">
                <h4 class="writer-assigned">
                    {{comment.commentable.writer.name}}
                </h4>
            </a>
        </div>

        <div class="comment">

            <p @click.prevent="showCommentDeleteModal()" v-if="comment.read_at != null" :title="'Read: ' + readAt" class="report tooltip">{{comment.created_at | fromNowAgo}}</p>
            <p @click.prevent="showCommentDeleteModal()" v-else class="report">{{comment.created_at | fromNowAgo}}</p>


            <p>Is assigned to complete the order</p>
            <span v-if="isPending(comment)" class="pin relative confirmation-pending">Confirmation Pending</span>

            <span v-if="isConfirmed(comment)" class="pin relative confirmation-pending">Confirmed</span>

            <span v-if="isRejected(comment)" class="pin relative confirmation-pending">Rejected</span>

            <span v-if="isReassigned(comment)" class="pin relative confirmation-pending">No response received</span>


            <div v-if="$user.isWriter() && $user.id() === comment.commentable.user_id" class="centered-buttons">
                <form v-if="$user.can('confirm', 'orderPolicy', order)" method="POST" id="order-confirm-form" action="/">
                    <button type="submit" @click.prevent="confirm()" class="button positive">Confirm</button>
                </form>

                <a v-if="$user.can('confirm', 'orderPolicy', order)" @click.prevent="showOrderRejectModal()" href="#reject-popup" class="button negative">Reject</a>
            </div>




            <div v-if="comment.commentable.writer.id === order.writer_id && $user.can('reassignWriter', 'orderPolicy', order)" class="centered-buttons">
                <a href="#reassign-popup" @click.prevent="showWriterReassignModal()">Reassign</a>
            </div>

        </div>
    </div>

</template>


<script>

    export default {
        props: ['comment', 'order'],
        data() {
            return {

            }
        },

        created(){
        },

        computed: {
            readAt: function () {
                return this.$options.filters.fromNowAgo(this.comment.read_at);
            }
        },

        methods: {
            isPending(comment) {
                return comment.commentable.status === 0
            },
            isConfirmed(comment) {
                return comment.commentable.status === 1
            },
            isRejected(comment) {
                return comment.commentable.status === 2
            },
            isReassigned(comment) {
                return comment.commentable.status === 3
            },

            showOrderRejectModal() {
                this.$modal.show('orderRejectModal',{ order: this.order})
            },
            showWriterReassignModal() {
                this.$modal.show('writerReassignModal',{ order: this.order})
            },
            showCommentDeleteModal() {
                if(this.$user.can('commentDelete', 'commentPolicy')) {
                    this.$modal.show('commentDeleteModal', {comment: this.comment})
                }
            },

            confirm() {

                    this.loading = true;

                    axios.post('/api/orders/actions/order-confirm', {
                        order_id: this.order.hashId,

                    }).catch(error => {
                        console.log(error);
                        flash('Given data was invalid', 'error');
                        this.loading = false;
                    })
                        .then(({data}) => {
                            flash(data.flash);
                            this.$eventBus.$emit('refreshOrder');
                            this.$eventBus.$emit('refreshComments');
                            this.loading = false;
                            this.hide()
                        });



            },

        }

    }
</script>